module.exports = __webpack_public_path__ + "static/media/TVHH_5-SumStat.827eb3c8.mp4";